export default __webpack_public_path__ + "img/es.5d6a69c7.svg";